"use client";

import { Provider } from "react-redux";
import { store } from "../redux/store";
import { ShoppingCartProvider } from "../contexts/CartContext";
import { CommonProvider } from "./context";

export function Providers({ children }) {
  return (
    <Provider store={store}>
      <ShoppingCartProvider>
        <CommonProvider>{children}</CommonProvider>
      </ShoppingCartProvider>
    </Provider>
  );
}
